<template>
    <div class="ranking-table-content border-radius-3 position-relative w-80 py-5">
        <div class="yellow-bar position-absolute"></div>
        <div
            :class="
                'd-flex justify-space-around align-center ' +
                (index === list_data.length - 1 ? '' : 'ranking-line')
            "
            v-for="(item, index) of list_data"
            :key="index"
        >
            <div cols="2" class="position-text position-absolute white--text">{{ index + 4 }}</div>
            <div
                class="d-flex justify-start align-center flex-row mx-10 pl-5"
                style="max-width: 20vh;"
            >
                <img
                    :src="`https://assets.beereaders.com/avatar/${item.avatar.name}/${item.avatar.value}`"
                    alt=""
                    height="75"
                    width="75"
                />
                <span class="text-body-1">{{ setName(item) }}</span>
            </div>
            <div class="d-flex justify-center align-center flex-row ">
                <div>
                    <span>Puntaje</span>
                </div>
                <PointHexagone :height="100" :width="100" class="pa-7"
                    ><span class="point-color font-size-18">{{ item.points }}</span></PointHexagone
                >
            </div>
            <div class="d-flex justify-center align-center flex-row ">
                <div>
                    <span>Nivel</span>
                </div>
                <vue-ellipse-progress
                    :progress="item.advancePercent"
                    :size="70"
                    :legend="false"
                    emptyColor="#816AD6"
                    :color="gradient"
                    thickness="10"
                    emptyThickness="10"
                    dot="15 #FFB600"
                    class="mx-1"
                >
                    <div slot="legend-caption" class="point-color font-size-18">
                        {{ item.userLevel }}
                    </div>
                </vue-ellipse-progress>
            </div>
        </div>
    </div>
</template>
<script>
import PointHexagone from '@/components/core/PointHexagone.vue'

export default {
    props: {
        list_data: { type: Array, default: null },
    },
    components: {
        PointHexagone,
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1',
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1',
                    },
                ],
            },
        }
    },
    methods: {
        setName(data) {
            return `${this.capitalizeText(data.firstName.split(' ')[0])} ${this.capitalizeText(
                data.lastName.split(' ')[0]
            )}`
        },
        capitalizeText(text) {
            return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase()
        },
    },
}
</script>

<style>
.yellow-bar {
    width: 10vh;
    left: 0;
    top: 0;
    bottom: 0;
    border-radius: 20px 0 0 20px;
    background: linear-gradient(180deg, #fec541 0%, #ffee7a 100%);
    box-shadow: -6px 4px 16px 5px rgba(0, 0, 0, 0.09);
}
.position-text {
    font-size: 48px;
    z-index: 10;
    text-align: center;
    left: 2.5vh;
    width: 5vh;
}
.ranking-table-content {
    background-color: #ffffff;
    box-shadow: -6px 4px 16px 5px rgba(0, 0, 0, 0.09);
}

.ranking-line {
    border-bottom: 1px solid #ebebeb;
}

.point-color {
    color: #816ad6;
}
</style>
